/**
 * See Array.isArray.
 * @memberof youbora.Util
 */
module.exports = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Array]'
}



//////////////////
// WEBPACK FOOTER
// ./~/youboralib/src/mixins/isarray.js
// module id = 14
// module chunks = 0